import { dataMember, required, typedArray } from 'santee-dcts';
import { CategoryNaturalKey } from './category';

export abstract class DocumentsCounterBase {

    @dataMember()
    @required({ nullable: true })
    public categoryId: CategoryNaturalKey;

    @dataMember()
    @required()
    public rootCategoryId: CategoryNaturalKey;

    @dataMember()
    @required()
    public totalDocs: number;

    public abstract get totalUnread(): number;
}

export class InvestigatorDocumentsCounter extends DocumentsCounterBase {
    @dataMember()
    @required()
    public subProtocolId: number;

    @dataMember()
    @required({ nullable: true })
    public siteId: number;

    @dataMember()
    @required()
    public unreadSiteCount: number;

    @dataMember()
    @required()
    public unreadAllSitesCount: number;

    public get totalUnread(): number {
        return this.unreadSiteCount + this.unreadAllSitesCount;
    }
}

export interface DocumentsCounterReadModel<T extends DocumentsCounterBase> {
    counters: T[];
}

export class InvestigatorDocumentsCounterReadModel implements DocumentsCounterReadModel<InvestigatorDocumentsCounter> {
    @dataMember()
    @required()
    @typedArray(InvestigatorDocumentsCounter)
    public counters: InvestigatorDocumentsCounter[];
}

export class GeneralDocumentsCounter extends DocumentsCounterBase {
    @dataMember()
    @required()
    public unreadCount: number;

    public get totalUnread(): number {
        return this.unreadCount;
    }
}

export class GeneralDocumentsCounterReadModel implements DocumentsCounterReadModel<GeneralDocumentsCounter> {
    @dataMember()
    @required()
    @typedArray(GeneralDocumentsCounter)
    public counters: GeneralDocumentsCounter[];
}

export class SponsorDocumentsCounter extends DocumentsCounterBase {
    @dataMember()
    @required()
    public protocolId: number;

    @dataMember()
    @required()
    public unreadCount: number;

    public get totalUnread(): number {
        return this.unreadCount;
    }
}

export class SponsorDocumentsCounterReadModel implements DocumentsCounterReadModel<SponsorDocumentsCounter> {
    @dataMember()
    @required()
    @typedArray(SponsorDocumentsCounter)
    public counters: SponsorDocumentsCounter[];
}